/**
 * React, react redux and react localization imports
 */
import { Box } from '@mui/material'
import { pallete } from '../../../theme'
import { TranslatableTypography } from './Typography'

const qrStyle = {
  wrapper: {
    padding: '10px',
    textAlign: 'center',
    '& .companion-qr-code-image': {
      width: '70%',
      height: '70%'
    },
    '@media (max-width:680px)': {
      '.companion-qr-code-image': {
        width: '60px',
        height: '60px'
      }
    }
  },
  label: { color: pallete.paperColor }
}

export const QRCode = ({ sx, labelSx }) => {
  return (
    <Box sx={{ ...qrStyle.wrapper, ...sx }}>
      <TranslatableTypography sx={{ ...qrStyle.label, ...labelSx }}>share-me</TranslatableTypography>
      <img src="/qr.png" alt="QR code for companion" className='companion-qr-code-image'/>
    </Box>
  )
}
